import React, { useMemo, useState } from 'react';
import GuidanceCheckBox from '../../Common/UI/CheckBox';
import Icons from '../../../../components/Common/Icons/Icons';
import FakePagination from '../../../../components/Common/UI/FakePagination';
import { cn } from '../../../../utils/styles';
import EmailsList from './EmailsList';
import NotificationsFooter from './Footer';

interface ITab {
  id: string;
  icon: React.ReactNode;
  label: string;
  active?: boolean;
}

function Notifications() {
  const [selectAll, setSelectAll] = useState<boolean>(false);

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
  };

  const tabs = useMemo(
    (): ITab[] => [
      {
        id: '1',
        icon: <Icons.Inbox />,
        label: 'Primary',
        active: true,
      },
      {
        id: '2',
        icon: <Icons.Tag />,
        label: 'Promotions',
      },
      {
        id: '3',
        icon: <Icons.Users />,
        label: 'Social',
      },
    ],
    [],
  );

  return (
    <div>
      <div className="bg-white rounded w-full rounded-tr-lg rounded-tl-lg">
        <div className="flex items-center px-[20px] py-[10px] justify-between border-b border-[#f7f8fc]">
          <div className="flex items-center gap-[20px]">
            <GuidanceCheckBox
              id="selectAll"
              checkBoxStyle="rounded-[3px] border-[2px] border-addition11 h-[19px] w-[19px]"
              wrapStyle="gap-[3px]"
              labelStyle="text-addition11 opacity-50"
              label={<Icons.ArrowRight className="rotate-90" />}
              checked={selectAll}
              onClick={handleSelectAll}
            />
            <Icons.Reload className="cursor-pointer" />
            <Icons.More className="cursor-pointer rotate-90" />
          </div>
          <div className="flex items-center gap-[30px]">
            <FakePagination value="1-4 of 4" />
            <div className="flex items-center text-addition11 cursor-pointer">
              <div className="opacity-60">En</div>
              <Icons.ArrowRight className="rotate-90 opacity-50" />
            </div>
          </div>
        </div>
        <div className="flex gap-[30px] pt-[15px] px-[20px] border-b border-[#f7f8fc]">
          {tabs.map(el => (
            <div
              key={el.id}
              className={cn(
                'flex items-center text-addition11 min-w-[180px] gap-[10px] pb-[10px] cursor-pointer' +
                  'text-[18px] font-medium',
                {
                  'text-[#6D71F8] [&_svg_path]:fill-[#6D71F8] border-b-[2px] border-[#6D71F8]': el.active,
                },
              )}
            >
              <div className="pl-[3px]">{el.icon}</div>
              {el.label}
            </div>
          ))}
        </div>
        <EmailsList />
      </div>
      <NotificationsFooter />
    </div>
  );
}

export default Notifications;
